/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 11/19/2019
 *
 * @version 0.10
 * Revisions:
 * 11/19/2019 - BW - Initial Creation
 * 07/22/2021 - BW - Modified: getPaymentToken - adjusted error catch to
 *                   use:"processErrorWithModalFailAlertWithNotifiedMessage" instead
 * 04/13/2022 - BW - Added: getInvoiceTotalColumnDefRenderFunction
 *                   Modified: _onFlashDriveCheckboxChange - added code to add/remove flashDrive amounts to
 *                   the total and balance as per Wayne.
 * 04/15/2022 - BW - Modified: getInvoiceTotalColumnDefRenderFunction - added "No Flash Drive" as per Wayne
 *                   Modified: _onFlashDriveCheckboxChange - added code for "No Flash Drive" as per Wayne
 * 07/15/2022 - BW - Modified: _onDataTableAjaxLoadComplete - added code for :"$accountCurrent"
 *                   Added: _processTotalBalance()
 * 07/27/2022 - BW - Modified: getInvoiceNumberColumnDefRenderFunction - modified: data to use FileLocationId
 * 08/12/2022 - BW - Modified: onInvoiceNotListedClick - show/hide "Conitnue" button as needed.
 *                   Modified: _onDataTableAjaxLoadComplete - added code to improve account current message
 * 09/08/2022 - BW - Added: _onPageHeaderActionCancelComplete()
 *                   Added: _onExportClickShowSuccess()
 * 12/05/2022 - BW - Modified: _onDataTableAjaxLoadComplete - added:"CommonUtil.show(this.$paymentButton)"
 * 03/21/2023 - BW - Modified: _processRow - added " .replace(/\\,/g,'') "
 *
 * Description/Purpose:
 * Payment JS
 ***************************************************************/
import '../../../scss/page/payment/payment.scss';

import StackTraceError from "component/stack-trace-error/stack-trace-error";
import LinkUtil from "util/link-util";
import {COMMON as COMMON_PAYMENT_UTIL, COMMON, PAGE_PARAM, TAG_DATA,} from "page/payment/payment-util";
import {
  APP as APP_CONSTANT_APP,
  MAX_CHAR,
  PAGE_PARAM as APP_CONSTANT_PAGE_PARAM,
  TAG_DATA as APP_CONSTANT_TAG_DATA,
  TEXT,
  VALIDATION_FORM
} from "constant/app-constant";
import ButtonUtil from "util/button-util";
import AjaxUtil from "util/ajax-util";
import ModalUtil from "util/modal-util";
import PaymentAjaxResponseJsonDto from "dto/payment-ajax-response-json-dto";
import PaymentAuthNet from "page/payment/payment-auth-net";
import PaymentProfile from "page/payment/payment-profile";
import CommonUtil from "util/common-util";
import PageControl from "component/page-control/page-control";
import Table from "component/table/table";
import PUBSUB_EVENT from "constant/pubsub-event";
import PubSub from 'pubsub-js';
import TableUtil from "component/table/table-util";
import {InputUtil} from "util/input-util";
import PaymentExtra from "page/payment/payment-extra";
import PaymentValidation from "page/payment/payment-validation";
import PaymentTableAjaxResponseJsonDto from "dto/payment-table-ajax-response-json-dto";


const Payment = {


  /**
   * Init function
   * @returns {Payment}
   */
  init() {
    try {
      this.setUpVariable();
      this.cacheDom();
      this.registerEvent();

      if (this.userAuthenticated.val() === 'true') {
        this._pageControl = new PageControl(this.$form,
            {
              loadingText: 'Loading Invoices',
            });
        if (APP_CONSTANT_TAG_DATA.SHOW_CHECKBOX === 'true') this.$checkboxDisplayed.val(true);
        this._table = new Table(this.$form,
            {
              servlet: this.urlPaymentServlet,
              tableType: 'invoices',
              noSearchRecordsFoundText: 'There Are No Outstanding Invoices Found',
              loadingText: 'Loading Invoices',
              tableClass: 'stripes',
              showSearch: false,
              showAdvancedSearch: false,
              showTableLength: false,
              showTableInfo: true,
              showPaging: false,
              runTableRowExpand: false,
              dataSrcFunction: this._onDataTableAjaxLoadComplete.bind(this),
              columnDefRenderArr: this._getColumnDefRenderArr.bind(this)(),
              fixedHeader: false,
              isDebug: true,
            });
        this._paymentProfile = new PaymentProfile(this.$form);
      }
      this._paymentExtra = PaymentExtra.init(this.$form);

      this.registerObject();
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Init');
    }
    return this;
  },


  /**
   * Setup some common vars
   */
  setUpVariable() {
    this._invoiceNumberColumnNumber = 'c3';
    this._invoiceTotalColumnNumber = 'c6';
    this._invoiceBalanceColumnNumber = 'c7';
    // this._invoiceBalanceColumnClass = 'seven';
    this._invoicePaymentColumnNumber = 'c8';
    this._flashDriveTotalColumnNumber = 'e1';
    this._isFlashDriveColumnNumber = 'c5';
    return this;
  },


  /**
   * Caches some often used DOM objects
   * @returns {Payment}
   */
  cacheDom() {
    try {
      this.$checkboxDisplayed = $(`#${APP_CONSTANT_PAGE_PARAM.CHECKBOX_DISPLAYED}`);
      this.$form = $(COMMON.FORM_SELECTOR);
      this.$selectText = $(`.${APP_CONSTANT_APP.SELECT_TEXT_CLASS}`);
      this.$table = $(TableUtil.TABLE_SELECTOR);
      this.userAuthenticated = $(COMMON.USER_AUTHENTICATED_SELECTOR);
      this.guestDisplay = TAG_DATA.GUEST_DISPLAY;
      this.$guestPaymentLink = $(COMMON.GUEST_PAYMENT_LINK_SELECTOR);
      this.$loginPaymentLink = $(COMMON.LOGIN_PAYMENT_LINK_SELECTOR);
      this.urlPaymentServlet = TAG_DATA.URL_PAYMENT_SERVLET;
      this.urlPaymentSimpleServlet = TAG_DATA.URL_PAYMENT_SIMPLE_SERVLET;
      this.urlLoginRedirect = TAG_DATA.URL_LOGIN_REDIRECT;
      this.urlHostedPaymentIFrameCommunicator = TAG_DATA.URL_HOSTED_PAYMENT_IFRAME_COMMUNICATOR;
      this.eActGetPaymentToken = TAG_DATA.E_ACT_GET_PAYMENT_TOKEN;
      this.eActValidateInvoiceNumber = TAG_DATA.E_ACT_VALIDATE_INVOICE_NUMBER;
      this.eActSave = TAG_DATA.E_ACT_SAVE;
      this.eActDisplayPaymentPage = TAG_DATA.E_ACT_DISPLAY_PAYMENT_PAGE;
      this.$paymentButton = $(COMMON.PAYMENT_BUTTON_SELECTOR);
      this.$invoiceNumber = $(COMMON.INVOICE_NUMBER_SELECTOR);
      this.$amount = $(COMMON.AMOUNT_SELECTOR);
      this.$token = $(COMMON.TOKEN_SELECTOR);
      this.$totalBalance = $(COMMON.TOTAL_BALANCE_SELECTOR);
      this.$totalBalanceRO = $(COMMON.TOTAL_BALANCE_RO_SELECTOR);
      this.$totalPayment = $(COMMON.TOTAL_PAYMENT_SELECTOR);
      this.$totalPaymentRO = $(COMMON.TOTAL_PAYMENT_RO_SELECTOR);
      this.$topDataContainer = $(COMMON.TOP_DATA_CONTAINER_SELECTOR);
      this.$invoiceNotListed = $(COMMON.INVOICE_NOT_LISTED_SELECTOR);
      this.$invoiceNotListedContainer = $(COMMON.INVOICE_NOT_LISTED_CLASS_SELECTOR);
      this.$invoicePaymentPSV = $(COMMON.INVOICE_PAYMENT_PSV_SELECTOR);
      // this.$invoicePaymentExtraPSV = $(COMMON_PAYMENT_EXTRA.INVOICE_PAYMENT_EXTRA_PSV_SELECTOR);
      this._defaultTotalAmountText = this.guestDisplay ? 'Enter invoices to pay' : 'Select invoices to pay';
      this.$organizationName = $(COMMON.ORGANIZATION_NAME_SELECTOR);
      this.$accountCurrentPortal = $(COMMON.ACCOUNT_CURRENT_PORTAL_SELECTOR);
      this.$accountCurrentDocket = $(COMMON.ACCOUNT_CURRENT_DOCKET_SELECTOR);
      this.$noAccount = $(COMMON.NO_ACCOUNT_SELECTOR);
      this.$navPortal = $('#nav_portal');
      this.$navDocket = $('#nav_docket');
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Cache Dom');
    }
    return this;
  },


  /**
   * Caches some often used DOM objects
   * @returns {Table}
   * @private
   */
  _cacheDataTable() {
    try {
      this._dataTable = TableUtil.getDataTable();
    } catch (e) {
      StackTraceError.processError(e, 'Table Checkbox - Cache Dom');
    }
    return this;
  },


  /**
   * Register events or DOM event
   * @private
   */
  registerEvent() {
    try {
      this.registerCharCountdown();
      this.registerOnlyNumbers();
      PubSub.subscribe(PUBSUB_EVENT.DATATABLE_INIT_COMPLETE, this._onDataTablesInitComplete.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.DATATABLE_DRAW_COMPLETE, this._onDataTablesDrawComplete.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.TABLE_CHECKBOX_CHECK_ALL_CHANGE, this._onCheckBoxChange.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.TABLE_CHECKBOX_UNCHECK_ALL_CHANGE, this._onCheckBoxChange.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.TABLE_ROW_CHECKBOX_CHANGE, this._onCheckBoxChange.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.PAYMENT_EXTRA_TEXT_CHANGE_COMPLETE, this._processTotalPaymentPubSub.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.PAYMENT_EXTRA_DELETE_SUCCESS_COMPLETE, this._processTotalPaymentPubSub.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.PAYMENT_EXTRA_VALIDATE_SUCCESS_COMPLETE, this._validateForm.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.EXPORT_CLICK_SHOW_SUCCESS, this._onExportClickShowSuccess.bind(this));
      PubSub.subscribe(PUBSUB_EVENT.PAGE_HEADER_ACTION_CANCEL_COMPLETE, this._onPageHeaderActionCancelComplete.bind(this));
      this.$table.on('click', `input.${COMMON.TABLE_FLASH_DRIVE_CHECKBOX_CLASS}`,
          ($event) => this._onFlashDriveCheckboxChange($event));
      this.$guestPaymentLink
          .off('click')
          .on('click', this.onGuestPaymentLinkClick.bind(this));
      this.$loginPaymentLink
          .off('click')
          .on('click', this.onLoginPaymentLinkClick.bind(this));
      this.$paymentButton
          .off('click')
          .on('click', this.onPaymentClick.bind(this));
      this.$invoiceNotListed
          .off('click')
          .on('click', this.onInvoiceNotListedClick.bind(this));
      if (!this.guestDisplay)
        this.$organizationName
            .off('change', ($event) => this.onOrganizationNameChange($event))
            .on('change', ($event) => this.onOrganizationNameChange($event));

    } catch (e) {
      StackTraceError.processError(e, 'Payment - Register Event');
    }
  },


  /**
   * Set up some objects
   */
  registerObject() {
    try {
      this.paymentValidation = new PaymentValidation(this.$form);
    } catch (e) {
      StackTraceError.processError(e,
          'File Upload Upload Validation Base - Register Objects');
    }
  },


  /**
   * Will setup the custom ColumnDefRenderArr for the Table class
   * @returns {*[]}
   * @private
   */
  _getColumnDefRenderArr() {
    // return [null, null, this.getEmailServiceColumnDefRenderFunction().bind(this)];
    return [null, null, this.getInvoiceNumberColumnDefRenderFunction(), null,
      this.getFlashDriveColumnDefRenderFunction(), this.getInvoiceTotalColumnDefRenderFunction(),
      this.getBalanceColumnDefRenderFunction(), this.getPaymentColumnDefRenderFunction()];
  },


  /**
   * Returns the custom "Invoice Number" (3rd column) column render function
   * @returns {function(*, *, *, *): *}
   */
  getInvoiceNumberColumnDefRenderFunction() {
    return function renderReturn(data, type, row, meta) {
      if (type === 'display') {
        const rnca = LinkUtil.addRandomNumber()
        //data = `<a href='${APP_CONSTANT_TAG_DATA.FILE_SERVLET_PATH}?${APP_CONSTANT_PAGE_PARAM.E_ID}=${row.eId}${rnca}'
        data = `<a href='${APP_CONSTANT_TAG_DATA.FILE_SERVLET_PATH}${row[TableUtil.HELPER_DTO_FILE_LOCATION_ID][TableUtil.HELPER_DTO_DISPLAY]}?${APP_CONSTANT_PAGE_PARAM.E_ID}=${row.eId}${rnca}'
                target='_blank' class='link link-with-text-decoration wrap-break-word'>${data}</a>`;
      }
      return data;
    };
  },


  /**
   * Returns the custom "Flash Drive" (5th column) column render function
   * @returns {function(*, *, *, *): *}
   */
  getFlashDriveColumnDefRenderFunction() {
    return function renderReturn(data, type, row, meta) {
      if (type === 'display') {
        if (data === 'true') {
          data = `<div class='table-column-center'><label class='selection-control disabled'>
                <input type='checkbox' class='checkbox flash-drive-checkbox' disabled>
                <span>&nbsp;</span>
            </label></div>`;
        } else {
          data = `<div class='table-column-center'>N/A</div>`;
        }
      }
      return data;
    };
  },


  /**
   * Returns the custom "Balance" (7th column) column render function
   * @returns {function(*, *, *, *): *}
   */
  getInvoiceTotalColumnDefRenderFunction() {
    const $this = this;
    return function renderReturn(data, type, row, meta) {
      if (type === 'display') {
        // console.log( row );
        const isFlashDiv = row[$this._isFlashDriveColumnNumber][TableUtil.HELPER_DTO_DISPLAY] === "true";
        const flashDriveDiv = isFlashDiv ?
            `<div class='${COMMON_PAYMENT_UTIL.TABLE_NO_FLASH_DRIVE_CLASS}'>No Flash Drive</div>`
            : '';
        data = `<div class='${COMMON_PAYMENT_UTIL.TABLE_INVOICE_TOTAL_CLASS}'>${data}</div>` + flashDriveDiv;
      }
      return data;
    };
  },

  /**
   * Returns the custom "Balance" (8th column) column render function
   * @returns {function(*, *, *, *): *}
   */
  getBalanceColumnDefRenderFunction() {
    return function renderReturn(data, type, row, meta) {
      if (type === 'display') {
        data = `<div class='${COMMON_PAYMENT_UTIL.TABLE_BALANCE_CLASS}'>${data}</div>`;
      }
      return data;
    };
  },


  /**
   * Returns the custom "Payment" (8th column) column render function
   * @returns {function(*, *, *, *): *}
   */
  getPaymentColumnDefRenderFunction() {
    return function renderReturn(data, type, row, meta) {
      if (type === 'display') {
        data = `<input type='text' class='text payment-input' name='payment_input_${row.id}' disabled>`;
      }
      return data;
    };
  },


  /**
   * Called when the Ajax data has completed
   * Need to return the actual table data for the DataTables
   * @param json
   * @returns {*}
   * @private
   */
  _onDataTableAjaxLoadComplete(json) {
    try {
      const paymentTableAjaxResponseJsonDto = new PaymentTableAjaxResponseJsonDto(json);
      this.paymentTableAjaxResponseJsonDtoData = paymentTableAjaxResponseJsonDto.data;

      // Add all balances
      let totalBalance = 0;
      for (let i = 0, len = this.paymentTableAjaxResponseJsonDtoData.length; i < len; i++) {
        const dto = this.paymentTableAjaxResponseJsonDtoData[i];
        totalBalance += parseFloat(dto[this._invoiceBalanceColumnNumber][TableUtil.HELPER_DTO_SORT]);
      }
      totalBalance = `$${totalBalance.toFixed(2)}`;
      this.$totalBalance.val(totalBalance);
      this.$totalBalanceRO.html(totalBalance);

      // Update table class if necessary
      if (paymentTableAjaxResponseJsonDto.isMultipleOrganization)
        this.$table.addClass(COMMON.TABLE_MULTIPLE_ORGANIZATION_CLASS);
      else
        this.$table.removeClass(COMMON.TABLE_MULTIPLE_ORGANIZATION_CLASS);

      // Show "Account Current" or not
      if (this.paymentTableAjaxResponseJsonDtoData.length === 0) {
        if (this.$organizationName.is("select")) {
          if (CommonUtil.isVisible(this.$navDocket))
            CommonUtil.show(this.$accountCurrentDocket);
          else if (CommonUtil.isVisible(this.$navPortal))
            CommonUtil.show(this.$accountCurrentPortal);
        } else {
          CommonUtil.show(this.$noAccount);
        }
        if (!InputUtil.isCheckBoxChecked(this.$invoiceNotListed))
          CommonUtil.hide(this.$paymentButton);
      } else {
        CommonUtil.hide(this.$accountCurrentPortal);
        CommonUtil.hide(this.$accountCurrentDocket);
        CommonUtil.hide(this.$noAccount);
        CommonUtil.show(this.$paymentButton);
      }

      PubSub.publish(PUBSUB_EVENT.DATATABLE_AJAX_LOAD_COMPLETE);
      return this.paymentTableAjaxResponseJsonDtoData;
    } catch (e) {
      StackTraceError.processError(e, 'Payment - On Data Table Ajax Load Complete');
    }
    return null;
  },


  /**
   * Processes the table row checkbox/check and "Select All" change
   * @param eventName
   * @param $tr
   * @private
   */
  _onCheckBoxChange(eventName, $tr) {
    try {
      if ($tr) {
        this._processRow($tr);
      } else {
        this._processSelectAll();
      }
      // Process Total Payment
      this._processTotalPayment(null, $tr);
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Table Row Check Box Change');
    }
  },


  /**
   * Process a TR
   * @param $tr
   * @private
   */
  _processRow($tr) {
    const isChecked = InputUtil.isCheckBoxChecked($tr.find('input:checkbox:first'));
    const $flashDriveCheckbox = $tr.find(`.${COMMON.TABLE_FLASH_DRIVE_CHECKBOX_CLASS}`);
    const $paymentInput = $tr.find(`.${COMMON.TABLE_PAYMENT_CLASS}`);
    const balanceHTML = $tr.find(`.${COMMON_PAYMENT_UTIL.TABLE_BALANCE_CLASS}`).html();
    const balance = balanceHTML.substring(1, balanceHTML.length).replace(/\,/g,'');
    //if ($flashDriveCheckbox.length > 0  && $paymentInput.length > 0) {
    if ($flashDriveCheckbox.length > 0) {
      if (isChecked) {
        InputUtil.makeSelectControlEnabled($flashDriveCheckbox);
      } else {
        InputUtil.makeSelectControlDisabled($flashDriveCheckbox);
        InputUtil.uncheckCheckBox($flashDriveCheckbox);
      }
    }

    if (isChecked) {
      $paymentInput.val(balance);
      CommonUtil.makeEnabled($paymentInput);
      $paymentInput.onlyNumbers();
      // Register textchange
      $paymentInput.off('textchange').on('textchange',
          ($event, previousText) => {
            this._processTotalPayment($event)
          });
    } else {
      $paymentInput.val('')
      $paymentInput.removeClass(VALIDATION_FORM.INVALID_CLASS);
      CommonUtil.makeDisabled($paymentInput);
    }

  },


  /**
   * Process a "Select All" checkbox"
   * @param $tr
   * @private
   */
  _processSelectAll($tr) {
    // const isChecked = InputUtil.isCheckBoxChecked(this.$checkAll)
    this.$table.find('tbody tr').each((index, value) => {
      this._processRow($(value));
    });
  },


  /**
   * Will loop through all the checked rows and set the total payment amount
   * @param $event
   * @param $tr
   * @private
   */
  _processTotalPayment($event = null, $tr = null) {
    let totalPayment = 0;
    this.$table.find(`.${COMMON.TABLE_PAYMENT_CLASS}`).each((index, value) => {
      const $this = $(value);
      const payment = parseFloat($this.val());
      // Add all payments
      if (payment > 0)
        totalPayment += payment;
    });

    // Grab any "extra" payments if available
    totalPayment += this._paymentExtra.getTotalAmount();

    // Render results to screen
    let totalPaymentFormatted = `$${totalPayment.toFixed(2)}`;
    this.$totalPayment.val(totalPaymentFormatted);
    if (totalPayment > 0)
      this.$totalPaymentRO.html(totalPaymentFormatted);
    else
      this.$totalPaymentRO.html(this._defaultTotalAmountText);

    // Update DatatableData
    if ($event != null || $tr != null)
      this._updateDatatablePayment($event, $tr);
    else {
      // Do all
      this.$table.find(`tbody tr.${TableUtil.SELECTED_CLASS}`)
          .each((index, value) => {
            const $tr2 = $(value);
            this._updateDatatablePayment($event, $tr2);
          });
    }
  },


  /**
   * Will loop through all the rows and set the total balance amount
   * @param $event
   * @param $tr
   * @private
   */
  _processTotalBalance($event = null, $tr = null) {
    let totalBalance = 0;
    this.$table.find(`.${COMMON.TABLE_BALANCE_CLASS}`).each((index, value) => {
      const $this = $(value);
      const balance = parseFloat($this.html().substr(1));
      // Add all payments
      if (balance > 0)
        totalBalance += balance;
    });

    // Render results to screen
    let totalBalanceFormatted = `$${totalBalance.toFixed(2)}`;
    this.$totalBalance.val(totalBalanceFormatted);
    this.$totalBalanceRO.html(totalBalanceFormatted);
  },


  /**
   * Will loop through all the checked rows and set the total payment amount
   * @param eventName
   * @private
   */
  _processTotalPaymentPubSub(eventName) {
    this._processTotalPayment();
  },


  /**
   * Validates form and gets the paymentToken
   * @private
   */
  _validateForm(eventName) {
    const result = this.$form.valid();
    if (result)
        // Get the Payment Token
      this.getPaymentToken();
  },


  /**
   * On Flash Drive checkbox un/check
   * @private
   */
  _onFlashDriveCheckboxChange($event) {
    const $this = $($event.currentTarget);
    const $tr = $this.closest('tr');
    const data = this._dataTable.row($tr).data();
    const $paymentInput = $tr.find(`.${COMMON.TABLE_PAYMENT_CLASS}`);
    const $invoiceTotalHTML = $tr.find(`.${COMMON_PAYMENT_UTIL.TABLE_INVOICE_TOTAL_CLASS}`);
    const $balanceHTML = $tr.find(`.${COMMON_PAYMENT_UTIL.TABLE_BALANCE_CLASS}`);
    const $noFlashDriveHTML = $tr.find(`.${COMMON_PAYMENT_UTIL.TABLE_NO_FLASH_DRIVE_CLASS}`);
    const flashDriveTotal = parseFloat(data[this._flashDriveTotalColumnNumber][TableUtil.HELPER_DTO_SORT]);
    let invoiceTotal = parseFloat(data[this._invoiceTotalColumnNumber][TableUtil.HELPER_DTO_SORT]);
    let invoiceBalance = parseFloat(data[this._invoiceBalanceColumnNumber][TableUtil.HELPER_DTO_SORT]);

    if (InputUtil.isCheckBoxChecked($this)) {
      invoiceTotal = invoiceTotal + flashDriveTotal;
      invoiceBalance = invoiceBalance + flashDriveTotal;
      CommonUtil.hide($noFlashDriveHTML);
      CommonUtil.makeDisabled($paymentInput);
    } else {
      CommonUtil.show($noFlashDriveHTML);
      CommonUtil.makeEnabled($paymentInput);
    }

    $paymentInput.val(invoiceBalance.toFixed(2));

    // Set html data
    $invoiceTotalHTML.html(`$${invoiceTotal.toFixed(2)}`);
    $balanceHTML.html(`$${invoiceBalance.toFixed(2)}`);

    // Process Total Payment
    this._processTotalPayment($event);
    this._processTotalBalance($event);
  },


  /**
   * Will update the data in the datatable with the new payment
   * @param $event
   * @param $tr
   * @private
   */
  _updateDatatablePayment($event = null, $tr = null) {
    if ($tr === null) {
      const $this = $($event.currentTarget);
      $tr = $this.closest('tr');
    }
    const $paymentInput = $tr.find(`.${COMMON.TABLE_PAYMENT_CLASS}`);
    const row = this._dataTable.row($tr);
    const data = row.data();
    data[this._invoicePaymentColumnNumber][TableUtil.HELPER_DTO_DISPLAY] = `$${$paymentInput.val()}`;
    data[this._invoicePaymentColumnNumber][TableUtil.HELPER_DTO_SORT] = $paymentInput.val();
  },


  /**
   * Registers any Char Countdowns
   * @private
   */
  registerCharCountdown() {
    this.registerCharCountdown = true; // eslint
    this.$invoiceNumber.charCountdown({ maxChar: MAX_CHAR.INVOICE_NUMBER });
  },


  /**
   * Registers the "Only Numbers" method
   * @private
   */
  registerOnlyNumbers() {
    this.$amount.onlyNumbers();
  },


  /**
   * Event Handler for the PUBSUB_EVENT.DATATABLE_DRAW_COMPLETE event
   * @param eventName
   * @param settings
   * @see table.js
   * @private
   */
  _onDataTablesDrawComplete(eventName, settings) {
    try {
      this._cacheDataTable();
      // Need this in case we need to switch between orgs in the Org dropdown
      this._processTotalPaymentPubSub();

      // Reset validation
      this.paymentValidation.resetForm();
      this.paymentValidation.reset();

    } catch (e) {
      StackTraceError.processError(e, 'Payment - DataTables Draw Complete');
    }
  },


  /**
   * Method fires when the DataTable Init has completed (only fires once)
   * @param event name - DATATABLE_INIT_COMPLETE
   * @param tableAjaxResponseJSONDTO
   * @private
   */
  _onDataTablesInitComplete(event, tableAjaxResponseJSONDTO) {
    try {
      CommonUtil.show(this.$selectText);
      CommonUtil.show(this.$invoiceNotListedContainer);
      CommonUtil.show(this.$topDataContainer);
    } catch (e) {
      StackTraceError.processError(e, 'Payment - DataTables Init Complete');
    }
  },


  /**
   * Processes Guest Payment Link Click
   * @param $event
   * @private
   */
  onGuestPaymentLinkClick($event) {
    try {
      $event.preventDefault();
      LinkUtil.openBasic(PAGE_PARAM.E_ACT_DISPLAY_PAYMENT_PAGE, null, this.urlPaymentSimpleServlet);
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Guest Payment Link Click');
    }
  },


  /**
   * Processes Login Payment Link Click
   * @param $event
   * @private
   */
  onLoginPaymentLinkClick($event) {
    try {
      $event.preventDefault();
      LinkUtil.openBasic(null, null, this.urlLoginRedirect);
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Guest Payment Link Click');
    }
  },


  /**
   * This function will perform an Ajax call to get the Authorize.Net Token and send along the
   * information from the form.  It will then call the openPaymentPopUp when successful
   * @param $event
   * @returns {boolean}
   * @private
   */
  onPaymentClick($event) {
    $event.preventDefault();
    try {
      this.paymentValidation.registerValidateForm(); // Add Dynamic Validation

      // Set the invoice payment data
      this.$invoicePaymentPSV.val(this.getInvoicePaymentPSV());

      // Validate the invoice numbers (Extra) if necessary
      this._paymentExtra.validatePaymentExtra($event);

    } catch (e) {
      StackTraceError.processError(e, 'Payment - Get Payment Token');
    }
  },


  /**
   * Will return the select records
   * @returns
   */
  getInvoicePaymentPSV() {
    let invoicePaymentPSV = "";
    try {
      if (this._dataTable) {
        const invoicePaymentColumnNumber = this._invoicePaymentColumnNumber;
        const invoiceNumberColumnNumber = this._invoiceNumberColumnNumber;
        this._dataTable.rows(`.${TableUtil.SELECTED_CLASS}`)
            .every(function getInvoicePaymentPSV(rowIdx, tableLoop, rowLoop) {
              invoicePaymentPSV += `${rowLoop !== 0 ? "|" : ""}`;
              const payment = this.data()[invoicePaymentColumnNumber][TableUtil.HELPER_DTO_DISPLAY];
              invoicePaymentPSV += `${this.data()[TableUtil.HELPER_DTO_ID]}~`
                  + `${this.data()[invoiceNumberColumnNumber][TableUtil.HELPER_DTO_DISPLAY]}~`
                  + `${payment.substring(1, payment.length)}`;
              return true;
            });
      }
    } catch (e) {
      StackTraceError.processError(e, 'Invoice Payment - Get Invoice Payment PSV');
    }
    return invoicePaymentPSV;
  },


  /**
   * This function will perform an Ajax call to get the Authorize.Net Token and send along the information from the form
   * It will then call the openPaymentPopUp when successful
   * @private
   */
  getPaymentToken() {
    try {
      // Create the WindowModal
      const modalContentSelector = `.${COMMON.PAYMENT_MODAL_CLASS} `
          + `.${ModalUtil.WINDOW_MODAL_CONTENT_CLASS}`;
      const iframeHTML = `<iframe name='${COMMON.PAYMENT_IFRAME_COMMUNICATOR_NAME}' `
          + `id='${COMMON.PAYMENT_IFRAME_COMMUNICATOR_NAME}' class='${COMMON.PAYMENT_IFRAME_COMMUNICATOR_CLASS}' `
          + `scrolling='no'></iframe>`;
      this.modalWindow = ModalUtil.showBlankWindowModalWithLoading([COMMON.PAYMENT_MODAL_CLASS],
          COMMON.PAYMENT_BANNER, COMMON.MODAL_HEADER, TEXT.LOADING, [], iframeHTML);

      // Saving
      ButtonUtil.enableProcessingButton(this.$paymentButton);

      //  Send ajax call to get the total row count data
      const request = AjaxUtil.postJsonToAjaxServlet(
          TAG_DATA.URL_PAYMENT_SERVLET,
          TAG_DATA.E_ACT_GET_PAYMENT_TOKEN,
          this.$form.serialize(), {},
      );
      request.always((data) => {
        // Always remove the Processing Button
        ButtonUtil.disableProcessingButton(this.$paymentButton);
      });
      request.done((data) => {
        const paymentAjaxResponseJsonDto = new PaymentAjaxResponseJsonDto(data);
        // Set token to hidden input
        this.$token.val(paymentAjaxResponseJsonDto.token);

        // Add iframe to modal
        this.$modalContent = $(modalContentSelector);

        // Submit the form
        this.$form.trigger('submit');

        // Show the content
        CommonUtil.show(this.$modalContent);
      });
      request.fail((jqXHR, textStatus, errorThrown) => {
        StackTraceError.processErrorWithModalFailAlertWithNotifiedMessage(
            new Error(errorThrown), 'Payment Token - Ajax Fail',
            'An error occurred retrieving the payment token and Case Anywhere has been notified.',
        );
        // ModalUtil.showModalFailAlertWithNotifiedMessage("An error occurred retrieving the "
        //             + "payment token and Case Anywhere has been notified.");
        // StackTraceError.processError(new Error(errorThrown), 'Payment Token - Ajax Fail');
      });
    } catch (e) {
      StackTraceError.processError(e, 'Payment Token - Continue Button Click');
    }
    return true;
  },


  /**
   * Invoice Not Listed Click Event Handler
   * @param $event
   * @private
   */
  onInvoiceNotListedClick() {
    try {
      debugger;
      const isChecked = this.$invoiceNotListed.prop("checked");
      if (isChecked) {
        this._paymentExtra.showPaymentExtraContent();
        CommonUtil.show(this.$paymentButton);
      } else {
        this._paymentExtra.hidePaymentExtraContent();
        if ($(TableUtil.TABLE_WRAPPER_SELECTOR).length == 0)
          CommonUtil.hide(this.$paymentButton);
      }
    } catch (e) {
      StackTraceError.processError(e, 'Payment - Invoice Not Listed Click ');
    }
  },


  /**
   * On Organization Name Change
   */
  onOrganizationNameChange() {
    InputUtil.uncheckCheckBox(this.$invoiceNotListed);
    this.onInvoiceNotListedClick();
    PubSub.publish(PUBSUB_EVENT.DATATABLE_AJAX_RELOAD_REQUEST);
    PubSub.publish(PUBSUB_EVENT.RELOAD_TOTAL_ROW_COUNT_REQUEST);
  },


  /**
   * When the export is clicked - we hide the "Payment" button
   * @private
   */
  _onExportClickShowSuccess() {
    CommonUtil.hide(this.$paymentButton);
  },


  /**
   * When the cancel is clicked - we show the "Payment" button
   * @private
   */
  _onPageHeaderActionCancelComplete() {
    CommonUtil.show(this.$paymentButton);
  },


};

$(() => {
  try {
    // this.payment = Payment.init();
    window.CAPayment = Payment.init();

    /** **************************************** */
    /** **** AUTH.NET *************************** */
    window.CommunicationHandler = {};
    // Will receive the communication from the iFrame via Authorize.Net
    window.CommunicationHandler.onReceiveCommunication = function onReceiveCommunication(argument) {
      const caPayment = window.CAPayment;
      this.paymentAuthNet = new PaymentAuthNet(caPayment.$form, caPayment.modalWindow,
          caPayment.$modalContent, argument);
    };
    /** **************************************** */
    /** **************************************** */
  } catch (e) {
    StackTraceError.processError(e, 'Payment Init Call');
  }
});
